import { GroupedCheckboxPicker } from '@statsbomb/kitbag-components';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsTouchDevice } from '@/hooks/useIsTouchDevice';

// The shared labels, select-all label and touch behaviour are identical for every picker, so the
// wrapper owns them and each consumer passes only the props that vary.
type CheckboxPickerProps = Pick<
  ComponentProps<typeof GroupedCheckboxPicker>,
  'groups' | 'title' | 'description' | 'searchPlaceholder' | 'selectedValues' | 'onSelectionChange' | 'selectAll'
>;

export const CheckboxPicker = ({
  groups,
  title,
  description,
  searchPlaceholder,
  selectedValues,
  onSelectionChange,
  selectAll,
}: CheckboxPickerProps) => {
  const { t } = useTranslation(['checkboxPicker', 'general']);
  const isTouch = useIsTouchDevice();

  return (
    <GroupedCheckboxPicker
      groups={groups}
      title={title}
      description={description}
      searchPlaceholder={searchPlaceholder}
      selectedValues={selectedValues}
      onSelectionChange={onSelectionChange}
      selectAll={selectAll}
      selectAllLabel={t('selectAll', { ns: 'general' })}
      isTouch={isTouch}
      viewMoreLabel={t('viewMore', { ns: 'general' })}
      viewLessLabel={t('viewLess', { ns: 'general' })}
      searchResultText={(count, searchValue) =>
        // React escapes text nodes itself, so i18next escaping would render e.g. "&#x2F;" literally
        t('searchSummary', { count, searchValue, interpolation: { escapeValue: false } })
      }
      groupSelectionLabel={(selected, total) => t('groupSelection', { selected, total })}
    />
  );
};
